<template>
<base-modal title="New Hero">
  <form>
    <div class="columns">
      <div class="column">
        <file-input required
          button-text="Choose a file"
          class="is-boxed"
          hint="1900px x 575px"
          @select="setFile" 
          :error="errors.file">
          Banner Image
        </file-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <submit-button 
          :working="working" 
          @submit="create" 
          class="is-success is-rounded">
          Save
        </submit-button>
      </div>
    </div>
  </form>
</base-modal>  
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {

  data: () => ({
    working: false
  }),

  beforeDestroy() {
    this.$store.commit('hero/reset')
  },

  computed: {
    ...mapState('hero', ['hero'])
  },

  methods: {
    ...mapMutations('hero', [
      'setFile'
    ]),
    
    create() {
      this.working = true
      this.$store.dispatch('hero/create').then(() => {
        this.$toast.success('Hero created')
        this.$close(true)
        }).catch(() => {
        }).then(() => {
          this.working = false
      })
    }
  }
}
</script>
